import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { Tabs, Tab } from 'react-bootstrap';

import { withRouter } from 'react-router-dom';
import Utility from '../../../../Utility/Utility';

import LoginActivity from '../Components/LoginActivity/LoginActivity';
class LoginActivityPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : ["agent", "agent_staff"].includes(this.props.userCredentials.user_details.user_type) ? "login_activity" : "",
            tabcontainerspace: "",
            tabchangeParent: false,
            tabChangeConfirmModal: false,
            tempTabName: "",
            branchId: "",
            quotationConvertBookingObj: {},
            quotationConvertBookingModalFlag: false,
            agentFlag: true,
            isMobileView: window.innerWidth < 767,
            tabContentList: [],
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.handleActiveLink("login_activity_module", "");
        // this.permissionWiseTabSelected();
        // this.initializeTabs();
    }

    //if previous params type not equals to updated params type then choose agent booking tab otherwise params tab
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.match.params.type != this.props.match.params.type) {
        //     this.setState({
        //         selectedTabName: this.props.match.params.type ? this.props.match.params.type : 'agent_booking'
        //     })
        // }

        // if (prevProps.match.params.branchId != this.props.match.params.branchId) {
        //     this.setState({
        //         branchId: this.props.match.params.branchId
        //     })
        // }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobileView: window.innerWidth <= 767 });
    };

    render() {
        // console.log("pagecontainer  >>>>>>", this.state.selectedTabName  )
        const { t, userCredentials } = this.props;
        const { tabcontainerspace, isMobileView, selectedTabName, tabContentList } = this.state;
        return (
            <div className={`${tabcontainerspace} ${(selectedTabName === "login_activity") ? "containerCover" : ""} homepagecontainer connectheader`}>
                <div className="tab-content">
                    <LoginActivity />
                </div>
            </div >
        );
    }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        access_token: globalState.mainReducerData.access_token,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        websocket: globalState.mainReducerData.websocket
    };
}

export default connect(mapStateToProps, { handleActiveLink, setUserCredentials })(withRouter(LoginActivityPage));
